import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PHONE_REGEX } from '@paymash/sdk/regex';

import { MatchValidator } from '@modules/core/form-validators';
import { ModelFormGroup } from '@modules/core/types';
import {
  AuthorizedForm,
  ContactDetailsForm,
  ExternalNoteForm,
  FeedbackForm,
  ForgotPasswordForm,
  LoginForm,
  RegistrationForm,
  ResetPasswordForm,
} from '@modules/core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private fb: FormBuilder) {}

  public initContactDetailsForm(): FormGroup<ModelFormGroup<ContactDetailsForm>> {
    return this.fb.group<ModelFormGroup<ContactDetailsForm>>({
      salutation: this.fb.control(null),
      firstName: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
      lastName: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
      email: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
      phone: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.pattern(PHONE_REGEX)], updateOn: 'blur' }),
      comment: this.fb.nonNullable.control('', { updateOn: 'blur' }),
    });
  }

  public initRegistrationForm(): FormGroup<ModelFormGroup<RegistrationForm>> {
    return this.fb.group<ModelFormGroup<RegistrationForm>>(
      {
        salutation: this.fb.control(null),
        firstName: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
        lastName: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
        email: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
        phone: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.pattern(PHONE_REGEX)], updateOn: 'blur' }),
        password: this.fb.nonNullable.control('', [Validators.required]),
        passwordConfirm: this.fb.nonNullable.control('', [Validators.required]),
      },
      {
        validators: MatchValidator('password', 'passwordConfirm'),
      }
    );
  }

  public initAuthorizedForm(): FormGroup<ModelFormGroup<AuthorizedForm>> {
    return this.fb.group<ModelFormGroup<AuthorizedForm>>({
      editMode: this.fb.nonNullable.control(false),
      salutation: this.fb.nonNullable.control(''),
      firstName: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
      lastName: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
      email: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
      phone: this.fb.nonNullable.control('',{ validators: [Validators.required, Validators.pattern(PHONE_REGEX)], updateOn: 'blur' }),
      comment: this.fb.nonNullable.control('', { updateOn: 'blur' }),
    });
  }

  public initLoginForm(): FormGroup<ModelFormGroup<LoginForm>> {
    return this.fb.group<ModelFormGroup<LoginForm>>({
      email: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
      password: this.fb.nonNullable.control('', { validators: [Validators.required]}),
    });
  }

  public initForgotPasswordForm(): FormGroup<ModelFormGroup<ForgotPasswordForm>> {
    return this.fb.group<ModelFormGroup<ForgotPasswordForm>>({
      email: this.fb.nonNullable.control('', { validators: [Validators.required, Validators.email], updateOn: 'blur' }),
    });
  }

  public initResetPasswordForm(): FormGroup<ModelFormGroup<ResetPasswordForm>> {
    return this.fb.group<ModelFormGroup<ResetPasswordForm>>(
      {
        password: this.fb.nonNullable.control('', [Validators.required]),
        passwordConfirm: this.fb.nonNullable.control('', [Validators.required]),
      },
      {
        validators: MatchValidator('password', 'passwordConfirm'),
      }
    );
  }

  initFeedbackForm(): FormGroup<ModelFormGroup<FeedbackForm>> {
    return this.fb.group<ModelFormGroup<FeedbackForm>>({
      state: this.fb.nonNullable.control('', [Validators.required]),
      text: this.fb.nonNullable.control('', { validators: [Validators.required], updateOn: 'blur' }),
    });
  }

  initExternalNoteForm(): FormGroup<ModelFormGroup<ExternalNoteForm>> {
    return this.fb.group<ModelFormGroup<ExternalNoteForm>>({
      externalNote: this.fb.nonNullable.control('', { updateOn: 'blur' }),
    });
  }
}
